import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Ensure external URLs have a valid protocol to avoid being treated as relative paths
// Also fixes malformed URLs like "https://http:s//domain.com" or "http:s//domain.com"
export function ensureExternalUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  let u = String(url).trim();
  if (!u) return null;
  
  // Fix malformed protocol patterns like "https://http:s//" or "http:s//" or "https:s//"
  // These occur from data entry errors
  u = u.replace(/^https?:\/\/https?:s?\/\//i, 'https://');
  u = u.replace(/^https?:s?\/\//i, 'https://');
  
  // Ensure URL starts with a valid protocol
  if (!/^https?:\/\//i.test(u)) {
    u = `https://${u}`;
  }
  return u;
}
